import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import MessagePageUI from './MessagePageUI.js'

class MessagePageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messageList: null,
    };
  }

  render() {
    let params = new URLSearchParams(window.location.search)
    let arg = params.get('arg')
    if (!['Facebook', 'Google'].includes(arg))
      arg = 'Unknown'

    let messageKey, messageArgs
    switch (params.get('key')) {
      case 'error':
        messageKey = 'c_unexpected_error'
        break;
      case 'invalid_session':
        messageKey = 'c_invalid_session'
        break;
      case 'login_with_google':
        messageKey = 'c_logged_in_with_g_b4'
        break;
      case 'login_with_fb':
        messageKey = 'c_logged_in_with_fb_b4'
        break;
      case 'login_cancelled':
        messageKey = 'c_soc_login_cancel'
        messageArgs = [arg]
        break;
      default:
    }

    return (
      <MessagePageUI
        context={this.props.context}
        messageList={this.state.messageList}
        messageKey={messageKey}
        messageArgs={messageArgs}
      />
    );
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
    document.body.classList.add('sdp')
  }

  getMessages(context) {
    let arr = [
      'c_continue',
      'c_unexpected_error',
      'c_invalid_session',
      'c_logged_in_with_g_b4',
      'c_logged_in_with_fb_b4',
      'c_soc_login_cancel',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_message', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default MessagePageSF
